import { Buffer } from "buffer";
import { DECODER_REGISTRY } from "./discriminatorRegistry.js";
import type { DecodeInput, DecodeResult } from "./types.js";

export function decodeProgramDataUnified(
  input: DecodeInput
): DecodeResult | null {
  const buf = Buffer.from(input.data, "base64");

  let discriminator: string | undefined;

  if (buf.length >= 8) {
    discriminator = buf.subarray(0, 8).toString("hex");
  }

  const keyWithDisc = discriminator
    ? `${input.programId}:${discriminator}`
    : null;

  const keyFallback = `${input.programId}:${input.context}`;

  const entry =
    (keyWithDisc && DECODER_REGISTRY.get(keyWithDisc)) ||
    DECODER_REGISTRY.get(keyFallback);

  if (!entry) return null;

  return {
    programId: input.programId,
    discriminator,
    type: entry.type,
    data: entry.decode(buf),
  };
}
